"use client";
import * as S from "./styles.ts";
import { H4, P } from "@template/components";
import { ReactElement } from "react";

type TCountry = {
  title: string;
  flag: ReactElement;
};

type TCountryGroup = {
  title: string;
  countries: TCountry[];
};

interface ICountriesPopoverProps {
  groups: TCountryGroup[];
}

const Country = ({ country }: { country: TCountry }) => (
  <S.Country>
    <S.CountryIcon>{country.flag}</S.CountryIcon>
    <S.CountryTitle>{country.title}</S.CountryTitle>
  </S.Country>
);

const Group = ({ group }: { group: TCountryGroup }) => (
  <S.Group>
    <P $small>{group.title}</P>
    <S.CountriesContainer>
      {group.countries.map((country, i) => (
        <Country
          country={country}
          key={i}
        />
      ))}
    </S.CountriesContainer>
  </S.Group>
);

const CountriesPopover = ({ groups }: ICountriesPopoverProps) => {
  return (
    <S.CountriesWrapper>
      <H4>Available Countries</H4>
      <S.GroupsContainer>
        {groups.map((group, i) => (
          <Group
            group={group}
            key={i}
          />
        ))}
      </S.GroupsContainer>
    </S.CountriesWrapper>
  );
};

export default CountriesPopover;
